const ready = require("%helpers%/document-ready.js");
import lazyload from "vanilla-lazyload";

ready(function() {
	const initLazyload = () => {
		new lazyload({
			elements_selector: ".lazy",
		});
	};

	initLazyload();
});